<!-- eslint-disable -->
<script setup>
import { openModal } from '@kolirt/vue-modal';
import Login from '../modals/Login.vue';
import Register from '../modals/Register.vue';
import LiveChatHeader from './LiveChatHeader.vue';
import SportsbookSearch from '../modals/SportsbookSearch.vue';
import SettingDropdown from '../Common/settingDropdown.vue';
import { useNavbarStore } from '@/stores/navbar_items';
import { BetSlip } from '@/stores/BetSlip';
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import { useI18n } from 'vue-i18n';
import ThemeSwitcher from '@/components/Common/ThemeSwitcher.vue';
import NotificationsDropdown from '@/components/Common/notificationsDropdown.vue';
import { useThemeStore } from '@/stores/themes';
import { useAgentStore } from '@/stores/agent';

const svgs_data = commonSvgs;
const navbarStore = useNavbarStore();
const agentStore = useAgentStore();
const betslipStore = BetSlip();
const themeStore = useThemeStore();

const { t } = useI18n();

const showLoginModal = () => {
	openModal(Login).then((data) => {
		if (data.show_register) showRegisterModal();
	}).catch(() =>{});
};

const showRegisterModal = () => {
	openModal(Register).then((data) => {
		if (data.show_login) showLoginModal();
	}).catch(() =>{});
};


const showSportsbookSearchModal = (event) => {
	event.stopPropagation();
	openModal(SportsbookSearch).then((data) => {
	}).catch(() =>{});
		betslipStore.is_betslip_opened = false;
		betslipStore.betSlipModel = '';
		navbarStore.user_dropdown_opened = false;
		navbarStore.settings_dropdown = false;
		navbarStore.mobile_menu = false;
};

const showSettings = () => {
	navbarStore.settings_dropdown = !navbarStore.settings_dropdown;
	navbarStore.user_dropdown_opened = false;
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
	navbarStore.mobile_menu = false;
};

</script>
<template>
	<div class="row-container">
		<div class="header-icons for-ghana">
			<LiveChatHeader/>
			<ThemeSwitcher v-if="Array.isArray(themeStore.themes) && themeStore.themes.length == 2"></ThemeSwitcher>
			<a @click="showSportsbookSearchModal($event)">
				<svg xmlns="http://www.w3.org/2000/svg" width="25.207" height="25.207" viewBox="0 0 25.207 25.207">
					<g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-1.75 -1.75)">
						<path id="Path_3" data-name="Path 3" d="M24.75,13.5A11.25,11.25,0,1,1,13.5,2.25,11.25,11.25,0,0,1,24.75,13.5Z" transform="translate(0)" fill="none" stroke="var(--another-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
						<path id="Path_4" data-name="Path 4" d="M17.23,17.225l-4.743-4.737" transform="translate(9.02 9.025)" fill="none" stroke="var(--another-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
					</g>
				</svg>
			</a>
			<div class="setting-main">
				<object  v-html="svgs_data.setting_icon" @click="showSettings()"></object>
				<div v-if="navbarStore.settings_dropdown" class="setting-dropdown-main is-ghana active">
					<setting-dropdown v-if="navbarStore.settings_dropdown"></setting-dropdown>
				</div>
			</div>
		</div>
			<a @click="showLoginModal()" class="btn-small">{{ $t('general.login') }}</a>
			<a v-if="agentStore.showRegisterModal" @click="showRegisterModal()" class="btn-small btn-secondary">{{ $t('general.register') }}</a>
		</div>


</template>
<style scoped>
.row-container {
	display: flex;
	align-items: center;
}

.for-ghana {
	margin-right: 10px;
}

.header-btn {
	margin-left: auto;
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.right-content .header-icons .setting-main .is-ghana {
		padding: 15px;
	}
	.btn-small {
		font-size: 11px;
		font-weight: 500;
		width: 50%;
	}
	a.btn-small.btn-secondary {
		margin-left: 10px;
	}
	html[dir="rtl"] .btn-small {
		width: auto;
	}
	html[dir="rtl"] a.btn-small.btn-secondary {
		margin-left: unset;
		margin-right: 10px;
	}
	.right-content .for-ghana a:first-child svg {
		width: 17px;
		top: unset;
	}

}

html[dir="rtl"] .for-ghana {
	margin-right: unset;
	margin-left: 10px;
}
</style>